import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ArrowUpRight, ArrowDownRight, Loader2 } from "lucide-react";

export default function Quotes() {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const isLive = quotes.some((q) => q.live);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const { data } = await api.get("/quotes");
        if (active) { setQuotes(data); setLoading(false); }
      } catch { setLoading(false); }
    };
    load();
    const t = setInterval(load, 3000);
    return () => { active = false; clearInterval(t); };
  }, []);

  if (loading) return <div className="flex items-center justify-center h-64"><Loader2 className="h-6 w-6 animate-spin text-white" /></div>;

  return (
    <div className="px-5 pt-6 pb-6 fade-up">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-heading text-3xl font-bold tracking-tight">Quotes</h1>
          <p className="text-[#888] text-sm mt-1">Live market watch — streaming prices.</p>
        </div>
        <div className="flex items-center gap-2 border border-[#222] bg-[#0F0F0F] px-3 py-1.5" data-testid="quotes-live-badge">
          <span className={`h-2 w-2 rounded-full ${isLive ? "bg-[#00F593] live-dot" : "bg-[#f5a623]"}`} />
          <span className="font-mono-term text-xs uppercase tracking-widest text-[#ccc]">{isLive ? "Live · MetaAPI" : "Simulated"}</span>
        </div>
      </div>

      <div className="border border-[#222] bg-[#0F0F0F]">
        <div className="grid grid-cols-[1.5fr_1fr_1fr_1fr] px-5 py-3 border-b border-[#222] font-mono-term text-xs uppercase tracking-widest text-[#666]">
          <span>Symbol</span><span className="text-right">Bid</span><span className="text-right">Ask</span><span className="text-right">Change</span>
        </div>
        {quotes.map((q) => {
          const up = q.change >= 0;
          return (
            <div key={q.symbol} data-testid={`quote-${q.symbol}`} className="grid grid-cols-[1.5fr_1fr_1fr_1fr] px-5 py-4 border-b border-[#222] items-center hover:bg-[#141414] transition-colors">
              <span className="font-mono-term font-semibold tracking-wide">{q.symbol}</span>
              <span className="text-right font-mono-term">{q.bid}</span>
              <span className="text-right font-mono-term text-[#888]">{q.ask}</span>
              <span className={`text-right font-mono-term flex items-center justify-end gap-1 ${up ? "text-[#00F593]" : "text-[#FF3B30]"}`}>
                {up ? <ArrowUpRight className="h-3.5 w-3.5" /> : <ArrowDownRight className="h-3.5 w-3.5" />}{Math.abs(q.change)}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
